import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { PROPERTY_ZONE_WITHOUT_COMMUNITY } from "./apiRoutes";

const mutateAddPropertyZone = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${PROPERTY_ZONE_WITHOUT_COMMUNITY}`, data);
};

const useAddPropertyZoneMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddPropertyZone,
    ...queryParams,
  });

export default useAddPropertyZoneMutation;
